<template>
  <div
    class="teacher-item-price"
    :class="{'teacher-item-price--active': isActive}"
  >
    <TeacherPriceFull />
  </div>
</template>

<script>
import TeacherPriceFull from '~/components/common/teacher-price/teacher-price-full'
export default {
  name: 'TeacherListItemsPrice',
  components: { TeacherPriceFull },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-item-price {
  @apply w-full lg:w-[150px] lg:px-8 py-2 border border-primary-100 rounded-2xl lg:rounded-lg
  flex flex-col justify-center items-center;
  &--active {
    @apply border-primary;
  }
}
</style>
